import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import {
  Network,
  SocialOAuthContext,
  SocialOAuthProvider,
  SocialProfileFields_InstagramSocialProfile_Fragment,
  StartSocialOAuthMutationFn
} from '../../../../models/graphql';
import { Modal } from '../../../../components/containers/Modal';
import { profilesHelpers } from '../Profiles.helpers';
import { AuthContextEnum } from '../../../../constants/auth';
import { BeaconContext } from '../../../../providers/BeaconProvider';

export type DirectPublishingModalViewProps = {
  //
  profile: SocialProfileFields_InstagramSocialProfile_Fragment;
  onClose: VoidFunction;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  startSocialOAuth: StartSocialOAuthMutationFn;
};

export const DirectPublishingModalView = (props: DirectPublishingModalViewProps): JSX.Element => {
  let content: JSX.Element | null = null;
  let modalTitle = '';
  let buttonText = '';
  let action: VoidFunction = () => {
    return;
  };
  useEffect(() => {
    // this will prevent the "leave site" browser pop up
    window.addEventListener('beforeunload', e => e.stopImmediatePropagation());
  }, []);

  const { beacon } = useContext(BeaconContext);

  switch (props.profile.type) {
    case 'business':
      content = (
        <>
          <p>To publish your content directly, please connect your Instagram Profile via Facebook.</p>
          <ul>
            <li>
              Your Instagram Profile needs to be connected to a Facebook Page.{' '}
              <a onClick={() => beacon('article', '722', { type: 'modal' })}>Learn more</a>
            </li>
            <li>You must be an admin of the Facebook Page.</li>
          </ul>
          <p>
            If you don&apos;t complete this process, you will receive mobile or email notifications when an Instagram
            Post is scheduled to be published manually.
          </p>
        </>
      );
      modalTitle = 'SET UP DIRECT PUBLISHING';
      buttonText = 'Continue to Facebook';
      action = () =>
        profilesHelpers.setNetworkAndCallOAuth({
          startSocialOAuth: props.startSocialOAuth,
          setLoading: props.setLoading,
          context: AuthContextEnum.toggleDirectPublishing,
          oAuthProvider: SocialOAuthProvider.FACEBOOK,
          profileNetwork: Network.INSTAGRAM,
          profile: props.profile,
          socialOAuthContext: SocialOAuthContext.RECONNECT
        });
      break;
    case 'personal':
    case 'media_creator':
      content = (
        <>
          <p>To publish your content directly, please connect your Instagram Profile via Facebook.</p>
          <ul>
            <li>
              Your Instagram Profile needs to be connected to a Facebook Page.{' '}
              <a onClick={() => beacon('article', '722', { type: 'modal' })}>Learn more</a>
            </li>
            <li>You must be an admin of the Facebook Page.</li>
          </ul>
          <p>
            If you don&apos;t complete this process, you will receive mobile or email notifications when an Instagram
            Post is scheduled to be published manually.
          </p>
        </>
      );
      modalTitle = 'SET UP DIRECT PUBLISHING';
      buttonText = 'Continue to Facebook';
      action = () =>
        profilesHelpers.setNetworkAndCallOAuth({
          startSocialOAuth: props.startSocialOAuth,
          setLoading: props.setLoading,
          context: AuthContextEnum.toggleDirectPublishing,
          oAuthProvider: SocialOAuthProvider.FACEBOOK,
          profileNetwork: Network.INSTAGRAM,
          profile: props.profile,
          socialOAuthContext: SocialOAuthContext.RECONNECT
        });
      break;
    case 'unknown':
      // It's just legacy and we shouldn't have to worry about an unknown type
      break;
  }

  return (
    <Modal
      onClose={props.onClose}
      showCloseIcon={!props.loading}
      closeOnClickOutside={false}
      size={'large'}
      primaryButtonLoading={props.loading}
      primaryButtonDisabled={props.loading}
      primaryButtonAction={action}
      primaryButtonTitle={buttonText}
      title={modalTitle}>
      {content}
    </Modal>
  );
};
